import { FC } from "react";

import { PriceRowProps } from "@models/services/pricing";

export const PriceRow: FC<PriceRowProps> = ({
  amount,
  firstRowClass = "col-9",
  label,
  labelClassName = "unit-prize-label",
  secondaryLabel,
  secondRowClass = "col-3 text-end",
  showMarginTop = false,
}) => {
  return (
    <div className={`row ${showMarginTop ? "mt-2" : ""}`}>
      <div className={firstRowClass}>
        <h5 className={labelClassName}>
          {label}
          {secondaryLabel && <span> {secondaryLabel}</span>}
        </h5>
      </div>
      <div className={secondRowClass}>
        <h5>{amount}</h5>
      </div>
    </div>
  );
};
